import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 73 73">
      <rect width="73" height="73" fill="#fff" rx="36.5"></rect>
      <path
        fill="#292A2C"
        d="M38.056 47.5l-1.633-1.612 6.723-6.724H25.733v-2.333h17.413l-6.723-6.702 1.633-1.633 9.502 9.502-9.502 9.502z"
      ></path>
    </svg>
  );
}

export default Icon;